// extracted by mini-css-extract-plugin
module.exports = {"container":"List_container_3iLna","batchTable":"List_batchTable_2h1Xz","detail":"List_detail_o0TOC"};